<template>
    <div>
    <router-view></router-view>
	</div>
</template>

<script>
export default {
    name: 'Dashboardview',
    data() {
      return {
      };
    },
  created() {
  }
  }
</script>

<style>


</style>